import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getNotificationsByUser, markNotificationAsRead, markAllNotificationsAsRead } from "../../services/notificationService";
import toast from "../../utils/toast";

const initialState = {
  notifications: null,
  unreadCount: 0,
  loading: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {
    updateUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    addNewNotification: (state, action) => {
      if (state.notifications) {
        state.notifications.unshift(action.payload);
      }
      state.unreadCount += 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotificationsByUser?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.notifications = action?.payload?.data;
        // Calculate unread count
        const unreadCount = action?.payload?.data?.filter(notification => !notification.isRead)?.length || 0;
        state.unreadCount = unreadCount;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(markNotificationAsRead?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        const notificationId = action?.payload?.data?.id;
        if (state.notifications) {
          const notification = state.notifications.find(n => n.id === notificationId || n._id === notificationId);
          if (notification && !notification.isRead) {
            notification.isRead = true;
            state.unreadCount = Math.max(0, state.unreadCount - 1);
          }
        }
      } else {
        // Only show error toast if it's not a development mode success
        if (action?.payload?.message && !action?.payload?.message.includes('dev mode')) {
          toast.error(action?.payload?.message || "Failed to mark notification as read");
        }
      }
      state.loading = false;
    });

    builder.addCase(markAllNotificationsAsRead?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        if (state.notifications) {
          state.notifications.forEach(notification => {
            notification.isRead = true;
          });
        }
        state.unreadCount = 0;
      } else {
        toast.error(action?.payload?.message || "Failed to mark all notifications as read");
      }
      state.loading = false;
    });

    builder
      .addMatcher(isAnyOf(getNotificationsByUser?.pending, markNotificationAsRead?.pending, markAllNotificationsAsRead?.pending), (state) => {
        state.loading = true;
      })
      .addMatcher(
        isAnyOf(getNotificationsByUser?.rejected, markNotificationAsRead?.rejected, markAllNotificationsAsRead?.rejected),
        (state, action) => {
          state.loading = false;
          toast.error(action?.payload?.message);
        }
      );
  },
});

export const { updateUnreadCount, addNewNotification } = notificationSlice?.actions;
export default notificationSlice?.reducer;
